<template>
    <div class="wrapper-img" :style="{width:theWidth, height:theHeight , minHeight:theMinHeight, 'background-image':`url(${img})`}">
        <div class="loadImg" :class="{hidden:img}" :style="{'background-color': '#E1E5E8'}">
          <div class="img-logo">
            <img src="/img/logo-areas-B&W.png" height="100px" width="100px">
          </div>
        </div>
    </div>
</template>


<script>
export default {
  name: 'imageLoader',
  props: {
    img: {
      type: String,
      // required: true,
    },
    theWidth: {
      type:String,
      default:'100%'
    },
    theHeight: {
      type:String,
      default:'auto'
    },
    theMinHeight: {
      type:String,
      default:'100%'
    }
  },

  data() {
    return {
      item:{
        src:'/img/loader.png'
      },      
    };
  },

  mounted() {
  },
};
</script>

<style scoped>
</style>
